<script>
  import { FAKE_PERSONNEL_LIST } from "@src/config/fake-evnet";

  export default {
    props: {
      personnelList: {
        type: Array,
        default: () => {
          return FAKE_PERSONNEL_LIST
        }
      }
    },
  }

</script>

<template>
  <div :class="$style.listPersonnels">
    <div :class="$style.personnelList">
      <div
        v-for="(personnelItem, index) in personnelList"
        :key="`personnelList-${index}`"
        class="personnelList__item"
      >
        <div class="d-flex">
          <div v-if="personnelItem.avatar" class="personnelList__left">
            <div
              class="personnelList__img"
              :style="{ backgroundImage: `url(${ personnelItem.avatar })` }"
            >
            </div>
          </div>
          <div class="personnelList__right">
            <p class="personnelList__name">
              <span class="font-medium text-lg">
                {{ personnelItem.title }} {{ personnelItem.name }}
              </span>
              <span class="personnelList__intro d-md-inline d-none">
                | {{ personnelItem.companyName }}
              </span>
              <span class="personnelList__intro d-md-none">
                {{ personnelItem.companyName }}
              </span>
            </p>
            <p
              class="personnelList__content d-md-block d-none article"
              style="white-space: pre-wrap;"
              v-html="personnelItem.description"
            ></p>
          </div>
        </div>
        <p
          class="personnelList__content d-md-none article"
          style="white-space: pre-wrap;"
          v-html="personnelItem.description"
        ></p>
      </div>
    </div>
  </div>
</template>
<style lang="scss" module>
  .listPersonnels {
    :global{
      .listPersonnels {

      }
    }
  }

  .personnelList {
    :global {
      .personnelList {
        &__item {
          margin-bottom: 1rem;

          // @include max-md {
          //   flex-direction: column;
          //   align-items: center;
          // }
        }

        &__left {
          flex-shrink: 0;
          width: 130px;
          margin-right: 20px;
          @include max-md {
            width: 95px;
          }
        }

        &__right {
          flex-grow: 1;
          padding-top: 10px;
        }

        &__img {
          position: relative;
          width: 100px;
          height: 100px;
          margin: 10px;
          background-image: url('~@assets/images/logo/logo_icon.png');
          background-position: center;
          background-size: cover;
          border-radius: 50%;
          @include max-md {
            width: 74px;
            height: 74px;
          }
          &::before {
            position: absolute;
            top: -10px;
            right: -10px;
            bottom: -10px;
            left: -10px;
            content: '';
            border: 1px solid $color-primary;
            border-radius: 100%;
          }

          // .img {
          //   width: 118px;
          //   height: 118px;
          //   padding: 10px;
          //   border: 1px solid $color-primary;
          //   border-radius: 50%;
          // }
        }
        &__name {
          font-size: 18px;
          font-weight: 500;
          color: $color-gray-7;
          @include max-md {
            display: flex;
            flex-direction: column;
          }
        }

        &__intro {
          margin-left: 10px;
          font-size: 16px;
          font-weight: 400;
          color: $color-gray-6;
          @include max-md {
            margin-left: 0;
            margin-top: 0.5rem;
          }
        }

        &__content {
          color: $color-gray-6;
        }
      }
    }
  }
  .detail {
    :global {
      .detail {
        &__box {
          padding-bottom: 20px;
        }

        &__session {
          padding-top: 20px;

          .detail__title {
            margin-bottom: 10px;
          }
        }

        &__title {
          margin-bottom: 30px;
          font-size: 20px;
          font-weight: 500;

          i {
            margin-right: 12px;
          }
        }



      }
    }
  }
</style>
